<template>
    <div class="user container h-100">
        <div class="header">
            <el-form class="form" label-width="100px" size="mini" inline>
                <el-form-item label="姓名" label-width="60px">
                    <el-input v-model="query.name" placeholder="请输入姓名" @change="searchBtn" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="60px">
                    <el-input v-model="query.mobile" placeholder="请输入手机号" @change="searchBtn" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-button--operation" size="mini"
                               style="margin-left:20px;" @click="searchBtn">查询
                    </el-button>
                    <el-button style="margin-right:0;" size="mini" @click="resetBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--    用户列表-->
        <el-row class="panel-container">
            <el-col :span="24">
                <div class="default-table mlTable-table" ref="tblDiv">
                    <el-table :data="userList" border>
<!--                        <el-table-column label="序号" type="index" align="center" width="55"></el-table-column>-->
                        <el-table-column label="序号" type="index" align="center" width="55">
                            <template slot-scope="{$index}">
                                {{ offset + $index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column label="头像" align="center" width="70px">
                            <template slot-scope="scope">
                                <el-avatar shape="square" :src="scope.row.avatar">
                                    <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                                </el-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" prop="name" align="center" width="120"></el-table-column>
                        <el-table-column label="职位" prop="title" align="center" width="120"></el-table-column>
                        <el-table-column label="直属上级" prop="manager_userid" align="center" width="120"></el-table-column>
                        <el-table-column label="邮箱" prop="email" align="center"></el-table-column>
                        <el-table-column label="手机" prop="mobile" align="center"></el-table-column>
                        <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
                        <el-table-column label="更新时间" prop="updated_at" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-link type="primary" icon="el-icon-refresh" @click="updateUser(scope.row.id)">更新</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="mlTable-page">
                        <div class="mlTable-do">
                            <el-tooltip class="item" effect="dark" content="刷新表格" placement="top">
                                <el-button @click="refreshBtn" icon="el-icon-refresh" circle
                                           style="margin-left:1px;margin-top: 10px"></el-button>
                            </el-tooltip>
                        </div>
                        <div class="mlTable-pagination">
                            <Pagination
                                    v-show="total>0"
                                    :total="total"
                                    :page.sync="params.current_page"
                                    :limit.sync="params.page_size"
                                    @pagination="handleQuery"
                            />
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>

</template>

<script>
  import { getDingUser,updateUser } from '@/api/dingTalk'
  export default {
    name: 'dingtalkUser',
    data(){
      return{
        // 查询条件
        query:{
          name:'',
          mobile:''
        },
        // 钉钉用户数据
        userList:[],
        params:{
          current_page: 1,
          page_size: 15,
        },
        total:0
      }
    },
    methods:{
      //获取钉钉用户列表数据
      getDingUserList(data) {
        getDingUser(data).then(res => {
          this.userList = res.model.list
          this.total = res.model.total
        })
      },
      handleSizeChange(pageSize){
        this.params.page_size = pageSize
        this.getDingUserList()
      },
      handleCurrentChange(current){
        this.params.current_page = current
        this.getDingUserList()
      },
      // 更新用户信息
      updateUser(id){
        updateUser(id).then(res => {
          if(res.code !== 100000){
            return this.$message.error('更新失败')
          }
          this.getDingUserList()
          this.$message.success('更新成功')
        })
      },
      // 刷新列表
      refreshBtn(){
        this.params.current_page = 1
        this.getDingUserList()
      },
      // 查询
      searchBtn(){
        this.params.current_page = 1
        this.handleQuery()
      },
      handleQuery() {
        this.getDingUserList({...this.query, ...this.params})
      },
      // 重置查询条件
      resetBtn() {
        this.query = {
          name:'',
          mobile:''
        }
        this.searchBtn()
      },
    },
    created(){
      this.getDingUserList(this.params)
    },
    computed:{
      offset() {
        return (this.params.current_page - 1) * this.params.page_size
      }
    }
  }
</script>

<style>
    .mlTable-page {
        display: flex;
        align-items: center;
        justify-content: right;
        padding:0 15px;
        margin-top: 5px;
    }
    .default-table tr.el-table__row .cell {
        height: 40px !important;
        line-height: 40px !important;
        font-weight: normal;
        font-size: 12px;
    }
</style>